var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "toggle-container box",
      attrs: { id: "accordion" + _vm.id_pax },
    },
    [
      _vm.modulo === "booking"
        ? [
            _c(
              "div",
              { staticClass: "tab-container full-width-style white-bg" },
              [
                _c("ul", { staticClass: "tabs" }, [
                  _c(
                    "li",
                    { class: { active: _vm.getActiveTabBooking("MEAL") } },
                    [
                      _vm.getBookingSrvcsMealExists
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#first-tab_" + _vm.id_pax,
                                "data-toggle": "tab",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "soap-icon-breakfast circle",
                              }),
                              _vm._v(
                                _vm._s(_vm.cat_meals[_vm.getCurrentLocale])
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.getActiveTabBooking("SERVICE") } },
                    [
                      _vm.getBookingSrvcsServiceExists
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#second-tab_" + _vm.id_pax,
                                "data-toggle": "tab",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "soap-icon-family circle",
                              }),
                              _vm._v(
                                _vm._s(_vm.cat_service[_vm.getCurrentLocale])
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.getActiveTabBooking("PETS") } },
                    [
                      _vm.getBookingSrvcsPetsExists
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#third-tab_" + _vm.id_pax,
                                "data-toggle": "tab",
                              },
                            },
                            [
                              _c("i", { staticClass: "soap-icon-dog circle" }),
                              _vm._v(
                                _vm._s(_vm.cat_pets[_vm.getCurrentLocale])
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.getActiveTabBooking("SPORTBAG") } },
                    [
                      _vm.getBookingSrvcsSportbagExists
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#fourth-tab_" + _vm.id_pax,
                                "data-toggle": "tab",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "soap-icon-playplace circle",
                              }),
                              _vm._v(
                                _vm._s(_vm.cat_sportbag[_vm.getCurrentLocale])
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.getActiveTabBooking("BAGGAGE") } },
                    [
                      _vm.getBookingSrvcsBaggageExists
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#fifth-tab_" + _vm.id_pax,
                                "data-toggle": "tab",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "soap-icon-suitcase circle",
                              }),
                              _vm._v(
                                _vm._s(_vm.cat_baggage[_vm.getCurrentLocale])
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.getActiveTabBooking("MEDICAL") } },
                    [
                      _vm.getBookingSrvcsMedicalExists
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#sixth-tab_" + _vm.id_pax,
                                "data-toggle": "tab",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "soap-icon-baggage-4 circle",
                              }),
                              _vm._v(
                                _vm._s(_vm.cat_medical[_vm.getCurrentLocale]) +
                                  " MICHAEL " +
                                  _vm._s(_vm.getActiveTabBooking("PRM"))
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.getActiveTabBooking("PRM") } },
                    [
                      _vm.getBookingSrvcsPrmExists
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#seventh-tab_" + _vm.id_pax,
                                "data-toggle": "tab",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "soap-icon-baggage-4 circle",
                              }),
                              _vm._v(_vm._s(_vm.cat_prm[_vm.getCurrentLocale])),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tab-content" }, [
                  _vm.getBookingSrvcsMealExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTabBooking("MEAL"),
                            active: _vm.getActiveTabBooking("MEAL"),
                          },
                          attrs: { id: "first-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_meals[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: {
                                id: "accordion" + _vm.id_pax + "_meals",
                              },
                            },
                            _vm._l(
                              _vm.getBookingPassengersSrvcsMeals,
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_meals",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-breakfast circle",
                                            srvcs_image:
                                              "/res/images/services/meals/meals_1.png",
                                            srvcs_type: "MEAL",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getBookingSrvcsServiceExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTabBooking("SERVICE"),
                            active: _vm.getActiveTabBooking("SERVICE"),
                          },
                          attrs: { id: "second-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_service[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: {
                                id: "accordion" + _vm.id_pax + "_service",
                              },
                            },
                            _vm._l(
                              _vm.getBookingPassengersSrvcsService,
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_service",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-family circle",
                                            srvcs_image:
                                              "/res/images/services/services/services_1.png",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getBookingSrvcsPetsExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTabBooking("PETS"),
                            active: _vm.getActiveTabBooking("PETS"),
                          },
                          attrs: { id: "third-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_pets[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: { id: "accordion" + _vm.id_pax + "_pets" },
                            },
                            _vm._l(
                              _vm.getBookingPassengersSrvcsPets,
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_pets",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon: "soap-icon-dog circle",
                                            srvcs_image:
                                              "/res/images/services/pets/pets_1.png",
                                            srvcs_type: "PETS",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getBookingSrvcsSportbagExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTabBooking("SPORTBAG"),
                            active: _vm.getActiveTabBooking("SPORTBAG"),
                          },
                          attrs: { id: "fourth-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_sportbag[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: {
                                id: "accordion" + _vm.id_pax + "_sportbag",
                              },
                            },
                            _vm._l(
                              _vm.getBookingPassengersSrvcsSportbag,
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_sportbag",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-playplace circle",
                                            srvcs_image:
                                              "/res/images/services/sportequipment/sportequipment_1.png",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getBookingSrvcsBaggageExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTabBooking("BAGGAGE"),
                            active: _vm.getActiveTabBooking("BAGGAGE"),
                          },
                          attrs: { id: "fifth-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_baggage[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: {
                                id: "accordion" + _vm.id_pax + "_baggage",
                              },
                            },
                            _vm._l(
                              _vm.getBookingPassengersSrvcsBaggage,
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_baggage",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-suitcase circle",
                                            srvcs_image:
                                              "/res/images/services/baggage/baggage_1.png",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getBookingSrvcsMedicalExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTabBooking("MEDICAL"),
                            active: _vm.getActiveTabBooking("MEDICAL"),
                          },
                          attrs: { id: "sixth-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_medical[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: {
                                id: "accordion" + _vm.id_pax + "_medical",
                              },
                            },
                            _vm._l(
                              _vm.getBookingPassengersSrvcsMedical,
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_medical",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-baggage-4 circle",
                                            srvcs_image:
                                              "/res/images/services/medical/medical_1.png",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getBookingSrvcsPrmExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTabBooking("PRM"),
                            active: _vm.getActiveTabBooking("PRM"),
                          },
                          attrs: { id: "seventh-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_medical[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: { id: "accordion" + _vm.id_pax + "_prm" },
                            },
                            _vm._l(
                              _vm.getBookingPassengersSrvcsPrm,
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_prm",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-baggage-4 circle",
                                            srvcs_image:
                                              "/res/images/services/medical/special_1.png",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.modulo === "services"
        ? [
            _c(
              "div",
              { staticClass: "tab-container full-width-style white-bg" },
              [
                _c("ul", { staticClass: "tabs" }, [
                  _c("li", { class: { active: _vm.getActiveTab("MEAL") } }, [
                    _vm.getServicesSrvcsMealExists
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: "#first-tab_" + _vm.id_pax,
                              "data-toggle": "tab",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "soap-icon-breakfast circle",
                            }),
                            _vm._v(_vm._s(_vm.cat_meals[_vm.getCurrentLocale])),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("li", { class: { active: _vm.getActiveTab("SERVICE") } }, [
                    _vm.getServicesSrvcsServiceExists
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: "#second-tab_" + _vm.id_pax,
                              "data-toggle": "tab",
                            },
                          },
                          [
                            _c("i", { staticClass: "soap-icon-family circle" }),
                            _vm._v(
                              _vm._s(_vm.cat_service[_vm.getCurrentLocale])
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("li", { class: { active: _vm.getActiveTab("PETS") } }, [
                    _vm.getServicesSrvcsPetsExists
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: "#third-tab_" + _vm.id_pax,
                              "data-toggle": "tab",
                            },
                          },
                          [
                            _c("i", { staticClass: "soap-icon-dog circle" }),
                            _vm._v(_vm._s(_vm.cat_pets[_vm.getCurrentLocale])),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "li",
                    { class: { active: _vm.getActiveTab("SPORTBAG") } },
                    [
                      _vm.getServicesSrvcsSportbagExists
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "#fourth-tab_" + _vm.id_pax,
                                "data-toggle": "tab",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "soap-icon-playplace circle",
                              }),
                              _vm._v(
                                _vm._s(_vm.cat_sportbag[_vm.getCurrentLocale])
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c("li", { class: { active: _vm.getActiveTab("BAGGAGE") } }, [
                    _vm.getServicesSrvcsBaggageExists
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: "#fifth-tab_" + _vm.id_pax,
                              "data-toggle": "tab",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "soap-icon-suitcase circle",
                            }),
                            _vm._v(
                              _vm._s(_vm.cat_baggage[_vm.getCurrentLocale])
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("li", { class: { active: _vm.getActiveTab("MEDICAL") } }, [
                    _vm.getServicesSrvcsMedicalExists
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: "#sixth-tab_" + _vm.id_pax,
                              "data-toggle": "tab",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "soap-icon-suitcase circle",
                            }),
                            _vm._v(
                              _vm._s(_vm.cat_medical[_vm.getCurrentLocale])
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("li", { class: { active: _vm.getActiveTab("PRM") } }, [
                    _vm.getServicesSrvcsPrmExists
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href: "#seventh-tab_" + _vm.id_pax,
                              "data-toggle": "tab",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "soap-icon-suitcase circle",
                            }),
                            _vm._v(_vm._s(_vm.cat_prm[_vm.getCurrentLocale])),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tab-content" }, [
                  _vm.getServicesSrvcsMealExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTab("MEAL"),
                            active: _vm.getActiveTab("MEAL"),
                          },
                          attrs: { id: "first-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_meals[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: {
                                id: "accordion" + _vm.id_pax + "_meals",
                              },
                            },
                            _vm._l(
                              _vm.getServicesPassengersSrvcsOfType({
                                type: "meal",
                              }),
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_meals",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-breakfast circle",
                                            srvcs_image:
                                              "/res/images/services/meals/meals_1.png",
                                            srvcs_type: "MEAL",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getServicesSrvcsServiceExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTab("SERVICE"),
                            active: _vm.getActiveTab("SERVICE"),
                          },
                          attrs: { id: "second-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_service[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: {
                                id: "accordion" + _vm.id_pax + "_service",
                              },
                            },
                            _vm._l(
                              _vm.getServicesPassengersSrvcsOfType({
                                type: "service",
                              }),
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_service",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-family circle",
                                            srvcs_image:
                                              "/res/images/services/services/services_1.png",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getServicesSrvcsPetsExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTab("PETS"),
                            active: _vm.getActiveTab("PETS"),
                          },
                          attrs: { id: "third-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_pets[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: { id: "accordion" + _vm.id_pax + "_pets" },
                            },
                            _vm._l(
                              _vm.getServicesPassengersSrvcsOfType({
                                type: "pets",
                              }),
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_pets",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon: "soap-icon-dog circle",
                                            srvcs_image:
                                              "/res/images/services/pets/pets_1.png",
                                            srvcs_type: "PETS",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getServicesSrvcsSportbagExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTab("SPORTBAG"),
                            active: _vm.getActiveTab("SPORTBAG"),
                          },
                          attrs: { id: "fourth-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_sportbag[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: {
                                id: "accordion" + _vm.id_pax + "_sportbag",
                              },
                            },
                            _vm._l(
                              _vm.getServicesPassengersSrvcsOfType({
                                type: "sportbag",
                              }),
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_sportbag",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-playplace circle",
                                            srvcs_image:
                                              "/res/images/services/sportequipment/sportequipment_1.png",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getServicesSrvcsBaggageExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTab("BAGGAGE"),
                            active: _vm.getActiveTab("BAGGAGE"),
                          },
                          attrs: { id: "fifth-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_baggage[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: {
                                id: "accordion" + _vm.id_pax + "_baggage",
                              },
                            },
                            _vm._l(
                              _vm.getServicesPassengersSrvcsOfType({
                                type: "baggage",
                              }),
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_baggage",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-suitcase circle",
                                            srvcs_image:
                                              "/res/images/services/baggage/baggage_1.png",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getServicesSrvcsMedicalExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTab("MEDICAL"),
                            active: _vm.getActiveTab("MEDICAL"),
                          },
                          attrs: { id: "sixth-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_medical[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: {
                                id: "accordion" + _vm.id_pax + "_medical",
                              },
                            },
                            _vm._l(
                              _vm.getServicesPassengersSrvcsOfType({
                                type: "medical",
                              }),
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_medical",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-baggage-4 circle",
                                            srvcs_image:
                                              "/res/images/services/medical/medical_1.png",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getServicesSrvcsPrmExists
                    ? _c(
                        "div",
                        {
                          staticClass: "tab-pane fade",
                          class: {
                            in: _vm.getActiveTab("PRM"),
                            active: _vm.getActiveTab("PRM"),
                          },
                          attrs: { id: "seventh-tab_" + _vm.id_pax },
                        },
                        [
                          _c("h3", { staticClass: "tab-content-title" }, [
                            _vm._v(
                              _vm._s(_vm.category[_vm.getCurrentLocale]) +
                                ": '" +
                                _vm._s(_vm.cat_prm[_vm.getCurrentLocale]) +
                                "'"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "toggle-container box",
                              attrs: { id: "accordion" + _vm.id_pax + "_prm" },
                            },
                            _vm._l(
                              _vm.getServicesPassengersSrvcsOfType({
                                type: "prm",
                              }),
                              function (srvcs, index) {
                                return _c(
                                  "div",
                                  {
                                    key: srvcs.id,
                                    staticClass: "panel style2",
                                  },
                                  [
                                    _c("h4", { staticClass: "panel-title" }, [
                                      _c(
                                        "a",
                                        {
                                          class: { collapsed: index !== 0 },
                                          attrs: {
                                            href:
                                              "#acc1" +
                                              _vm.id_pax +
                                              "_" +
                                              srvcs.id,
                                            "data-toggle": "collapse",
                                            "data-parent":
                                              "#accordion" +
                                              _vm.id_pax +
                                              "_prm",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " >>> " +
                                              _vm._s(srvcs.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "panel-collapse collapse",
                                        class: { in: index === 0 },
                                        attrs: {
                                          id:
                                            "acc1" +
                                            _vm.id_pax +
                                            "_" +
                                            srvcs.id,
                                        },
                                      },
                                      [
                                        _c("sdr-service-details", {
                                          attrs: {
                                            id_pax: _vm.id_pax,
                                            srvcs: srvcs,
                                            soap_icon:
                                              "soap-icon-baggage-4 circle",
                                            srvcs_image:
                                              "/res/images/services/medical/special_1.png",
                                            modulo: _vm.modulo,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }